import { Controller, ControllerProps, FieldValues } from "react-hook-form";
import { Text } from "react-native";
import { TextInputProps } from "ui/atoms/input/interfaces";
import { TextInput } from "ui/atoms/input/TextInput";
import { View } from "ui/atoms/view";
import {
  FormControl,
  FormControlError,
  FormControlErrorIcon,
  FormControlErrorText,
  FormControlHelper,
  FormControlHelperText,
} from "ui/gluestack/form-control";
import { AlertCircleIcon } from "ui/gluestack/icon";
import { requiredValidation } from "ui/utils/Validators";
export interface Props<TFieldValues extends FieldValues = FieldValues> {
  id: string;
  name: ControllerProps<TFieldValues>["name"];
  unit?: string;
  placeholder?: string;
  helperText?: string;
  type?: TextInputProps["type"];
  invalidMessage?: string;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  onChangeText?: (value?: string) => void;
  onSubmitEditing?: () => void;
  control: ControllerProps<TFieldValues>["control"];
  rules?: ControllerProps<TFieldValues>["rules"];
  className?: string;
}

export function FormControlledLargeTextInput<
  TFieldValues extends FieldValues = FieldValues,
>({
  id,
  name,
  isInvalid,
  isReadOnly,
  isDisabled,
  isRequired,
  placeholder,
  unit,
  type = "text",
  invalidMessage,
  helperText,
  control,
  rules,
  onSubmitEditing,
  className,
}: Props<TFieldValues>) {
  const localRules = {
    required: isRequired ? requiredValidation(unit ?? "Field") : undefined,
    ...rules,
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ fieldState: { error }, field: { value, onChange, name } }) => (
        <FormControl
          isInvalid={isInvalid || !!error}
          size="md"
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          isRequired={isRequired}
        >
          <View className={` my-1 ${className}`}>
            <View className="flex-row items-center">
              <TextInput
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                type={type}
                onSubmitEditing={onSubmitEditing}
                className="truncate px-1 w-20 border-0 text-3xl flex-1 text-right"
                variant="underlined"
              />
              {unit && <Text className=" right-0 text-base ">{unit}</Text>}
            </View>
          </View>

          {helperText ? (
            <FormControlHelper>
              <FormControlHelperText className="text-gray-500">
                {helperText ?? " "}
              </FormControlHelperText>
            </FormControlHelper>
          ) : null}
          {invalidMessage || error?.message ? (
            <FormControlError>
              <FormControlErrorIcon
                as={AlertCircleIcon}
                className="text-error-500"
                size="sm"
              />
              <FormControlErrorText className="text-error-500 text-sm">
                {error?.message || invalidMessage}
              </FormControlErrorText>
            </FormControlError>
          ) : null}
        </FormControl>
      )}
      rules={localRules}
    />
  );
}
